import { Button, TextInput, required, useNotify, useRefresh } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";

import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";

const AdditionalDataField = ({ field, currentValue }) => {
  const source = `additionalData.${field.key}`;
  const isDate = field.key.toLowerCase().includes("date");

  return isDate ? (
    <CustomDateInput
      noTime
      source={source}
      label={field.labelBg}
      defaultValue={currentValue || null}
      validate={[required()]}
    />
  ) : (
    <TextInput
      source={source}
      label={field.labelBg}
      defaultValue={currentValue || ""}
      validate={[required()]}
      fullWidth
    />
  );
};

const EditPreferenceAdditionalDataDialog = ({ mainId, preference, fields, disabled, handleKey }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleMap = {
    student: studentRequests.updateStudentPreferenceAdditionalData,
    candidacy: candidateRequests.updateCandidacyPreferenceAdditionalData,
  }

  const handleSubmit = async data => {
    // Full replace — send exactly the valid key set of this preference.
    await dataProvider.customRequest(
      handleMap[handleKey](mainId, preference.preferenceId),
      { additionalData: data.additionalData },
      "PUT",
    );
    notify("Успешно записване на допълнителните данни", { type: "success" });
    refresh();
  }

  const hasExistingData = Object.values(preference?.additionalData ?? {}).some(Boolean);

  return (
    <FormModal
      titleContent={hasExistingData ? "Редактиране на допълнителни данни" : "Добавяне на допълнителни данни"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label={hasExistingData ? "Редактирай" : "Добави"}
          disabled={disabled}
          startIcon={<EditIcon />}
        />
      }
    >
      {fields?.map(field => (
        <AdditionalDataField
          key={field.key}
          field={field}
          currentValue={preference?.additionalData?.[field.key]}
        />
      ))}
    </FormModal>
  );
};

export default EditPreferenceAdditionalDataDialog;
